/**
 * Capitalizes the first letter of each word in a string
 * @param str
 */
export const formatTitleCase = (str: string) => {
  return str?.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase())
}
